import {Platform, TouchableOpacity, View} from 'react-native';
import * as React from 'react';
import {DropdownMenuItemTypes, IStateProps} from './model';
import {useStyles} from '../../../../hooks/styles';
import {CustomView} from '../../../customView';
import {useCallback, useEffect, useRef} from 'react';
import {Text} from '../../../text';
import {useTheme} from '../../../../theme';

export default ({children, onClick, isActive, items, close, style}: IStateProps) => {
  const theme = useTheme();
  const styles = useStyles(() => ({
    container: {
      position: 'relative',
      zIndex: 2,
      height: 50,
    },
    childrenWrapper: {
      height: 50,
      flexDirection: 'row',
      alignItems: 'center',
    },
    dropdownMenu: {
      width: 'max-content',
      position: 'absolute',
      top: '107%',
      right: 60,
      zIndex: 2,
      backgroundColor: theme.color.primaryNonGreyBackground,
      shadowRadius: 18,
      shadowOffset: {width: 0, height: 4},
      shadowColor: theme.color.primaryBlackColor,
      shadowOpacity: 0.18,
      paddingTop: 12,
      paddingBottom: 12,
    },
    dropdownMenuItem: {
      paddingLeft: 28,
      paddingRight: 28,
      paddingTop: 8,
      paddingBottom: 8,
      flexDirection: 'row',
      alignItems: 'center',
    },
    dropdownMenuItemIcon: {
      marginRight: 8,
    },
    dropdownMenuItemSplitter: {
      marginTop: 12,
      marginBottom: 12,
      height: 1,
      backgroundColor: theme.header.dropdownMenuSplitterColor,
      width: '100%',
    },
    dropdownMenuItemText: {
      ...theme.fonts.h6Light,
    },
  }));

  if (Platform.OS === 'web') {
    const dropdownMenu = useRef<any>();
    const clickCallback = useCallback(
      (e: MouseEvent) => {
        if (isActive) {
          if (!dropdownMenu.current?.contains(e.target as Node)) {
            close();
          }
        }
      },
      [dropdownMenu?.current, close, isActive],
    );
    useEffect(() => {
      dropdownMenu.current = document.querySelector("[data-class='dropdown-menu']");
      window.addEventListener('click', clickCallback);
      return () => {
        window.removeEventListener('click', clickCallback);
      };
    }, [clickCallback]);
  }

  return (
    <CustomView style={[styles.container, style]} className='dropdown-menu'>
      <TouchableOpacity testID='dropdown-menu-container-id' onPress={onClick}>
        <View style={styles.childrenWrapper}>{children}</View>
      </TouchableOpacity>
      {isActive ? (
        <View style={styles.dropdownMenu}>
          {items.map((item, i) => {
            if (item.type === DropdownMenuItemTypes.splitter) {
              return <View key={i} style={styles.dropdownMenuItemSplitter} />;
            }
            const Icon = item.icon;
            return (
              <TouchableOpacity
                testID={`dropdown-menu-item-${i}-id`}
                onPress={() => {
                  onClick();
                  if (item.onPress) {
                    item.onPress();
                  }
                }}
                key={i}>
                <CustomView className={'dropdown-menu-item'} style={[styles.dropdownMenuItem, item.style]}>
                  {Icon ? (
                    <View style={styles.dropdownMenuItemIcon}>
                      <Icon width={24} height={24} color={theme.color.textColor} />
                    </View>
                  ) : null}
                  <Text style={styles.dropdownMenuItemText}>{item.label}</Text>
                </CustomView>
              </TouchableOpacity>
            );
          })}
        </View>
      ) : null}
    </CustomView>
  );
};
